export default __webpack_public_path__ + "static/media/polygonLogoWithText.247ea5f7.png";